import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

function Loader({ loading, style }) {
  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
          ...style
        }}
      >
        <div
          style={{
            width: "1rem",
            height: "1rem",
            lineHeight: "1rem",
            textAlign: "center"
          }}
        >
          <FontAwesomeIcon icon={faSpinner} spin />
        </div>
      </div>
    );
  }
  return null;
}

export default Loader;
